const SubAbasAlertas = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/maisopcoes/alertas/ficha/${id}/dadosgerais`,
  },
  //   {
  //     label: 'Produtos',
  //     rota: `/daf/produtosdaf/denominacoes/ficha/${id}/produtos`,
  //   },
];

export default SubAbasAlertas;
